import React from "react";
import { FormattedMessage } from "react-intl";
import {
  Typography,
  Button,
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import Question from "icons/question.svg";

const useStyles = makeStyles(() => ({
  confirmModal: {
    padding: "16px !important",
  },
  header: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    marginBottom: "16px",
  },
}));

const ConfirmModal = ({ isOpen, setIsOpen, handleConfirm, labelId, title, description, confirmLabel, cancelLabel }) => {
  const classes = useStyles();

  const handleConfirmClick = (e) => {
    setIsOpen(false);
    handleConfirm(e);
  };

  return (
    <Dialog open={isOpen} onClose={() => setIsOpen(false)}>
      <Box className={classes.confirmModal}>
        <DialogTitle className={classes.header}>
          <Typography variant="h4">
            {title || <FormattedMessage id="are_you_sure" />}
          </Typography>
          <img src={Question} style={{ width: "140px" }} />
        </DialogTitle>
        <DialogContent>
          <Typography variant="body1">
            {description || <FormattedMessage id={labelId} />}
          </Typography>
        </DialogContent>
        <DialogActions style={{ justifyContent: "space-around" }}>
          <Button
            variant="rounded"
            color="primaryContained"
            style={{ width: "140px", fontFamily: "Segoe UI Semibold, sans-serif" }}
            onClick={handleConfirmClick}
          >
            {confirmLabel || <FormattedMessage id="confirm" />}
          </Button>
          <Button
            variant="rounded"
            color="secondaryOutlined"
            style={{ width: "140px", fontFamily: "Segoe UI Semibold, sans-serif" }}
            onClick={() => setIsOpen(false)}
          >
            {cancelLabel || <FormattedMessage id="cancel" />}
          </Button>
        </DialogActions>
      </Box>
    </Dialog>
  );
};

export default ConfirmModal;
